import React from 'react'
import { Helmet } from 'react-helmet'

export const BrandingFooter = () => {
	return (
		<>
			<Helmet>
				<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />

				<meta name="viewport" content="width=device-width, initial-scale=1.0" />
				<meta http-equiv="X-UA-Compatible" content="IE=edge" />
				<meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
				<title>Search Jobs | Planet Healthcare</title>
				<meta
					name="description"
					content="Planet Healthcare is a leading staffing and recruitment firm providing nurses and medical professionals to clients in the medical industry."
				/>
				<link rel="canonical" href="http://www.planet-healthcare.com/clients" />
				<link rel="preload" href="https://www.planet-healthcare.com/assets/fonts/fa-solid-900.woff2" as="font" type="font/woff2" crossorigin="anonymous" />
				<link rel="preload" href="https://www.planet-healthcare.com/assets/fonts/fa-regular-400.woff2" as="font" type="font/woff2" crossorigin="anonymous" />
				<link rel="shortcut icon" href="https://www.planet-healthcare.com/favicon.ico" />
				<link rel="apple-touch-icon" sizes="180x180" href="https://static.animusrex.com/planet-healthcare/images/favicons/apple-touch-icon.png" />
				<link rel="icon" type="image/png" sizes="32x32" href="https://static.animusrex.com/planet-healthcare/images/favicons/favicon-32x32.png" />
				<link rel="icon" type="image/png" sizes="16x16" href="https://static.animusrex.com/planet-healthcare/images/favicons/favicon-16x16.png" />
				<link rel="manifest" href="https://static.animusrex.com/planet-healthcare/images/favicons/site.webmanifest" />
				<link rel="mask-icon" href="https://static.animusrex.com/planet-healthcare/images/favicons/safari-pinned-tab.svg" color="#5bbad5" />
				<meta name="msapplication-TileColor" content="#ffffff" />
				<meta name="msapplication-config" content="https://static.animusrex.com/planet-healthcare/images/favicons/browserconfig.xml" />
				<meta name="theme-color" content="#ffffff" />
				<meta property="og:url" content="https://www.planet-healthcare.com/clients/index" />
				<meta property="og:title" content="Client Overview | Planet Healthcare | Staffing and Recruitment Solutions" />
				<meta
					property="og:description"
					content="Planet Healthcare is a leading staffing and recruitment firm providing nurses and medical professionals to clients in the medical industry."
				/>
				<meta property="og:image" content="https://www.planet-healthcare.com/images/layout/og-logo.jpg" />
				<script type="text/javascript" async="" src="/assets/planet/scripts/js"></script>
				<script async="" src="/assets/planet/scripts/gtm.js"></script>
				<script type="application/ld+json" nonce="">
					{`{
        "@context": "http://schema.org",
        "@type": "Organization",
        "url": "https://www.planet-healthcare.com",
        "logo": "https://www.planet-healthcare.com/images/layout/planet-healthcare-logo-primary.png",
        "name": "Planet Healthcare",
        "sameAs": ["https://www.linkedin.com/company/planethealthcare"]
      }`}
				</script>
				<link rel="stylesheet" id="wp-block-library-css" href="/assets/planet/scripts/style.min.css" media="all" />
				<style id="wp-block-library-theme-inline-css">
					{` .wp-block-audio figcaption {
        color: #555;
        font-size: 13px;
        text-align: center;
      }
      .is-dark-theme .wp-block-audio figcaption {
        color: #ffffffa6;
      }
      .wp-block-audio {
        margin: 0 0 1em;
      }
      .wp-block-code {
        border: 1px solid #ccc;
        border-radius: 4px;
        font-family: Menlo, Consolas, monaco, monospace;
        padding: 0.8em 1em;
      }
      .wp-block-embed figcaption {
        color: #555;
        font-size: 13px;
        text-align: center;
      }
      .is-dark-theme .wp-block-embed figcaption {
        color: #ffffffa6;
      }
      .wp-block-embed {
        margin: 0 0 1em;
      }
      .blocks-gallery-caption {
        color: #555;
        font-size: 13px;
        text-align: center;
      }
      .is-dark-theme .blocks-gallery-caption {
        color: #ffffffa6;
      }
      .wp-block-image figcaption {
        color: #555;
        font-size: 13px;
        text-align: center;
      }
      .is-dark-theme .wp-block-image figcaption {
        color: #ffffffa6;
      }
      .wp-block-image {
        margin: 0 0 1em;
      }
      .wp-block-pullquote {
        border-bottom: 4px solid;
        border-top: 4px solid;
        color: currentColor;
        margin-bottom: 1.75em;
      }
      .wp-block-pullquote cite,
      .wp-block-pullquote footer,
      .wp-block-pullquote__citation {
        color: currentColor;
        font-size: 0.8125em;
        font-style: normal;
        text-transform: uppercase;
      }
      .wp-block-quote {
        border-left: 0.25em solid;
        margin: 0 0 1.75em;
        padding-left: 1em;
      }
      .wp-block-quote cite,
      .wp-block-quote footer {
        color: currentColor;
        font-size: 0.8125em;
        font-style: normal;
        position: relative;
      }
      .wp-block-quote.has-text-align-right {
        border-left: none;
        border-right: 0.25em solid;
        padding-left: 0;
        padding-right: 1em;
      }
      .wp-block-quote.has-text-align-center {
        border: none;
        padding-left: 0;
      }
      .wp-block-quote.is-large,
      .wp-block-quote.is-style-large,
      .wp-block-quote.is-style-plain {
        border: none;
      }
      .wp-block-search .wp-block-search__label {
        font-weight: 700;
      }
      .wp-block-search__button {
        border: 1px solid #ccc;
        padding: 0.375em 0.625em;
      }
      :where(.wp-block-group.has-background) {
        padding: 1.25em 2.375em;
      }
      .wp-block-separator.has-css-opacity {
        opacity: 0.4;
      }
      .wp-block-separator {
        border: none;
        border-bottom: 2px solid;
        margin-left: auto;
        margin-right: auto;
      }
      .wp-block-separator.has-alpha-channel-opacity {
        opacity: 1;
      }
      .wp-block-separator:not(.is-style-wide):not(.is-style-dots) {
        width: 100px;
      }
      .wp-block-separator.has-background:not(.is-style-dots) {
        border-bottom: none;
        height: 1px;
      }
      .wp-block-separator.has-background:not(.is-style-wide):not(
          .is-style-dots
        ) {
        height: 2px;
      }
      .wp-block-table {
        margin: 0 0 1em;
      }
      .wp-block-table td,
      .wp-block-table th {
        word-break: normal;
      }
      .wp-block-table figcaption {
        color: #555;
        font-size: 13px;
        text-align: center;
      }
      .is-dark-theme .wp-block-table figcaption {
        color: #ffffffa6;
      }
      .wp-block-video figcaption {
        color: #555;
        font-size: 13px;
        text-align: center;
      }
      .is-dark-theme .wp-block-video figcaption {
        color: #ffffffa6;
      }
      .wp-block-video {
        margin: 0 0 1em;
      }
      .wp-block-template-part.has-background {
        margin-bottom: 0;
        margin-top: 0;
        padding: 1.25em 2.375em;
      }`}
				</style>
				<style id="classic-theme-styles-inline-css">
					{`
      .wp-block-button__link {
        color: #fff;
        background-color: #32373c;
        border-radius: 9999px;
        box-shadow: none;
        text-decoration: none;
        padding: calc(0.667em + 2px) calc(1.333em + 2px);
        font-size: 1.125em;
      }
      .wp-block-file__button {
        background: #32373c;
        color: #fff;
        text-decoration: none;
      }
        `}
				</style>
				<style id="global-styles-inline-css">
					{`
      body {
        --wp--preset--color--black: #000000;
        --wp--preset--color--cyan-bluish-gray: #abb8c3;
        --wp--preset--color--white: #ffffff;
        --wp--preset--color--pale-pink: #f78da7;
        --wp--preset--color--vivid-red: #cf2e2e;
        --wp--preset--color--luminous-vivid-orange: #ff6900;
        --wp--preset--color--luminous-vivid-amber: #fcb900;
        --wp--preset--color--light-green-cyan: #7bdcb5;
        --wp--preset--color--vivid-green-cyan: #00d084;
        --wp--preset--color--pale-cyan-blue: #8ed1fc;
        --wp--preset--color--vivid-cyan-blue: #0693e3;
        --wp--preset--color--vivid-purple: #9b51e0;
        --wp--preset--color--fl-heading-text: #37a89b;
        --wp--preset--color--fl-body-bg: #f2f2f2;
        --wp--preset--color--fl-body-text: #606060;
        --wp--preset--color--fl-accent: #37a89b;
        --wp--preset--color--fl-accent-hover: #37a89b;
        --wp--preset--color--fl-topbar-bg: #ffffff;
        --wp--preset--color--fl-topbar-text: #757575;
        --wp--preset--color--fl-topbar-link: #37a89b;
        --wp--preset--color--fl-topbar-hover: #00a894;
        --wp--preset--color--fl-header-bg: #ffffff;
        --wp--preset--color--fl-header-text: #757575;
        --wp--preset--color--fl-header-link: #757575;
        --wp--preset--color--fl-header-hover: #37a89b;
        --wp--preset--color--fl-nav-bg: #ffffff;
        --wp--preset--color--fl-nav-link: #757575;
        --wp--preset--color--fl-nav-hover: #37a89b;
        --wp--preset--color--fl-content-bg: #ffffff;
        --wp--preset--color--fl-footer-widgets-bg: #ffffff;
        --wp--preset--color--fl-footer-widgets-text: #757575;
        --wp--preset--color--fl-footer-widgets-link: #37a89b;
        --wp--preset--color--fl-footer-widgets-hover: #00a894;
        --wp--preset--color--fl-footer-bg: #ffffff;
        --wp--preset--color--fl-footer-text: #757575;
        --wp--preset--color--fl-footer-link: #37a89b;
        --wp--preset--color--fl-footer-hover: #00a894;
        --wp--preset--gradient--vivid-cyan-blue-to-vivid-purple: linear-gradient(
          135deg,
          rgba(6, 147, 227, 1) 0%,
          rgb(155, 81, 224) 100%
        );
        --wp--preset--gradient--light-green-cyan-to-vivid-green-cyan: linear-gradient(
          135deg,
          rgb(122, 220, 180) 0%,
          rgb(0, 208, 130) 100%
        );
        --wp--preset--gradient--luminous-vivid-amber-to-luminous-vivid-orange: linear-gradient(
          135deg,
          rgba(252, 185, 0, 1) 0%,
          rgba(255, 105, 0, 1) 100%
        );
        --wp--preset--gradient--luminous-vivid-orange-to-vivid-red: linear-gradient(
          135deg,
          rgba(255, 105, 0, 1) 0%,
          rgb(207, 46, 46) 100%
        );
        --wp--preset--gradient--very-light-gray-to-cyan-bluish-gray: linear-gradient(
          135deg,
          rgb(238, 238, 238) 0%,
          rgb(169, 184, 195) 100%
        );
        --wp--preset--gradient--cool-to-warm-spectrum: linear-gradient(
          135deg,
          rgb(74, 234, 220) 0%,
          rgb(151, 120, 209) 20%,
          rgb(207, 42, 186) 40%,
          rgb(238, 44, 130) 60%,
          rgb(251, 105, 98) 80%,
          rgb(254, 248, 76) 100%
        );
        --wp--preset--gradient--blush-light-purple: linear-gradient(
          135deg,
          rgb(255, 206, 236) 0%,
          rgb(152, 150, 240) 100%
        );
        --wp--preset--gradient--blush-bordeaux: linear-gradient(
          135deg,
          rgb(254, 205, 165) 0%,
          rgb(254, 45, 45) 50%,
          rgb(107, 0, 62) 100%
        );
        --wp--preset--gradient--luminous-dusk: linear-gradient(
          135deg,
          rgb(255, 203, 112) 0%,
          rgb(199, 81, 192) 50%,
          rgb(65, 88, 208) 100%
        );
        --wp--preset--gradient--pale-ocean: linear-gradient(
          135deg,
          rgb(255, 245, 203) 0%,
          rgb(182, 227, 212) 50%,
          rgb(51, 167, 181) 100%
        );
        --wp--preset--gradient--electric-grass: linear-gradient(
          135deg,
          rgb(202, 248, 128) 0%,
          rgb(113, 206, 126) 100%
        );
        --wp--preset--gradient--midnight: linear-gradient(
          135deg,
          rgb(2, 3, 129) 0%,
          rgb(40, 116, 252) 100%
        );
        --wp--preset--font-size--small: 13px;
        --wp--preset--font-size--medium: 20px;
        --wp--preset--font-size--large: 36px;
        --wp--preset--font-size--x-large: 42px;
        --wp--preset--spacing--20: 0.44rem;
        --wp--preset--spacing--30: 0.67rem;
        --wp--preset--spacing--40: 1rem;
        --wp--preset--spacing--50: 1.5rem;
        --wp--preset--spacing--60: 2.25rem;
        --wp--preset--spacing--70: 3.38rem;
        --wp--preset--spacing--80: 5.06rem;
        --wp--preset--shadow--natural: 6px 6px 9px rgba(0, 0, 0, 0.2);
        --wp--preset--shadow--deep: 12px 12px 50px rgba(0, 0, 0, 0.4);
        --wp--preset--shadow--sharp: 6px 6px 0px rgba(0, 0, 0, 0.2);
        --wp--preset--shadow--outlined: 6px 6px 0px -3px rgba(255, 255, 255, 1),
          6px 6px rgba(0, 0, 0, 1);
        --wp--preset--shadow--crisp: 6px 6px 0px rgba(0, 0, 0, 1);
      }
      :where(.is-layout-flex) {
        gap: 0.5em;
      }
      :where(.is-layout-grid) {
        gap: 0.5em;
      }
      body .is-layout-flex {
        display: flex;
      }
      body .is-layout-flex {
        flex-wrap: wrap;
        align-items: center;
      }
      body .is-layout-flex > * {
        margin: 0;
      }
      body .is-layout-grid {
        display: grid;
      }
      body .is-layout-grid > * {
        margin: 0;
      }
      :where(.wp-block-columns.is-layout-flex) {
        gap: 2em;
      }
      :where(.wp-block-columns.is-layout-grid) {
        gap: 2em;
      }
      :where(.wp-block-post-template.is-layout-flex) {
        gap: 1.25em;
      }
      :where(.wp-block-post-template.is-layout-grid) {
        gap: 1.25em;
      }
      .has-black-color {
        color: var(--wp--preset--color--black) !important;
      }
      .has-cyan-bluish-gray-color {
        color: var(--wp--preset--color--cyan-bluish-gray) !important;
      }
      .has-white-color {
        color: var(--wp--preset--color--white) !important;
      }
      .has-pale-pink-color {
        color: var(--wp--preset--color--pale-pink) !important;
      }
      .has-vivid-red-color {
        color: var(--wp--preset--color--vivid-red) !important;
      }
      .has-luminous-vivid-orange-color {
        color: var(--wp--preset--color--luminous-vivid-orange) !important;
      }
      .has-luminous-vivid-amber-color {
        color: var(--wp--preset--color--luminous-vivid-amber) !important;
      }
      .has-light-green-cyan-color {
        color: var(--wp--preset--color--light-green-cyan) !important;
      }
      .has-vivid-green-cyan-color {
        color: var(--wp--preset--color--vivid-green-cyan) !important;
      }
      .has-pale-cyan-blue-color {
        color: var(--wp--preset--color--pale-cyan-blue) !important;
      }
      .has-vivid-cyan-blue-color {
        color: var(--wp--preset--color--vivid-cyan-blue) !important;
      }
      .has-vivid-purple-color {
        color: var(--wp--preset--color--vivid-purple) !important;
      }
      .has-black-background-color {
        background-color: var(--wp--preset--color--black) !important;
      }
      .has-cyan-bluish-gray-background-color {
        background-color: var(--wp--preset--color--cyan-bluish-gray) !important;
      }
      .has-white-background-color {
        background-color: var(--wp--preset--color--white) !important;
      }
      .has-pale-pink-background-color {
        background-color: var(--wp--preset--color--pale-pink) !important;
      }
      .has-vivid-red-background-color {
        background-color: var(--wp--preset--color--vivid-red) !important;
      }
      .has-luminous-vivid-orange-background-color {
        background-color: var(
          --wp--preset--color--luminous-vivid-orange
        ) !important;
      }
      .has-luminous-vivid-amber-background-color {
        background-color: var(
          --wp--preset--color--luminous-vivid-amber
        ) !important;
      }
      .has-light-green-cyan-background-color {
        background-color: var(--wp--preset--color--light-green-cyan) !important;
      }
      .has-vivid-green-cyan-background-color {
        background-color: var(--wp--preset--color--vivid-green-cyan) !important;
      }
      .has-pale-cyan-blue-background-color {
        background-color: var(--wp--preset--color--pale-cyan-blue) !important;
      }
      .has-vivid-cyan-blue-background-color {
        background-color: var(--wp--preset--color--vivid-cyan-blue) !important;
      }
      .has-vivid-purple-background-color {
        background-color: var(--wp--preset--color--vivid-purple) !important;
      }
      .has-black-border-color {
        border-color: var(--wp--preset--color--black) !important;
      }
      .has-cyan-bluish-gray-border-color {
        border-color: var(--wp--preset--color--cyan-bluish-gray) !important;
      }
      .has-white-border-color {
        border-color: var(--wp--preset--color--white) !important;
      }
      .has-pale-pink-border-color {
        border-color: var(--wp--preset--color--pale-pink) !important;
      }
      .has-vivid-red-border-color {
        border-color: var(--wp--preset--color--vivid-red) !important;
      }
      .has-luminous-vivid-orange-border-color {
        border-color: var(
          --wp--preset--color--luminous-vivid-orange
        ) !important;
      }
      .has-luminous-vivid-amber-border-color {
        border-color: var(--wp--preset--color--luminous-vivid-amber) !important;
      }
      .has-light-green-cyan-border-color {
        border-color: var(--wp--preset--color--light-green-cyan) !important;
      }
      .has-vivid-green-cyan-border-color {
        border-color: var(--wp--preset--color--vivid-green-cyan) !important;
      }
      .has-pale-cyan-blue-border-color {
        border-color: var(--wp--preset--color--pale-cyan-blue) !important;
      }
      .has-vivid-cyan-blue-border-color {
        border-color: var(--wp--preset--color--vivid-cyan-blue) !important;
      }
      .has-vivid-purple-border-color {
        border-color: var(--wp--preset--color--vivid-purple) !important;
      }
      .has-vivid-cyan-blue-to-vivid-purple-gradient-background {
        background: var(
          --wp--preset--gradient--vivid-cyan-blue-to-vivid-purple
        ) !important;
      }
      .has-light-green-cyan-to-vivid-green-cyan-gradient-background {
        background: var(
          --wp--preset--gradient--light-green-cyan-to-vivid-green-cyan
        ) !important;
      }
      .has-luminous-vivid-amber-to-luminous-vivid-orange-gradient-background {
        background: var(
          --wp--preset--gradient--luminous-vivid-amber-to-luminous-vivid-orange
        ) !important;
      }
      .has-luminous-vivid-orange-to-vivid-red-gradient-background {
        background: var(
          --wp--preset--gradient--luminous-vivid-orange-to-vivid-red
        ) !important;
      }
      .has-very-light-gray-to-cyan-bluish-gray-gradient-background {
        background: var(
          --wp--preset--gradient--very-light-gray-to-cyan-bluish-gray
        ) !important;
      }
      .has-cool-to-warm-spectrum-gradient-background {
        background: var(
          --wp--preset--gradient--cool-to-warm-spectrum
        ) !important;
      }
      .has-blush-light-purple-gradient-background {
        background: var(--wp--preset--gradient--blush-light-purple) !important;
      }
      .has-blush-bordeaux-gradient-background {
        background: var(--wp--preset--gradient--blush-bordeaux) !important;
      }
      .has-luminous-dusk-gradient-background {
        background: var(--wp--preset--gradient--luminous-dusk) !important;
      }
      .has-pale-ocean-gradient-background {
        background: var(--wp--preset--gradient--pale-ocean) !important;
      }
      .has-electric-grass-gradient-background {
        background: var(--wp--preset--gradient--electric-grass) !important;
      }
      .has-midnight-gradient-background {
        background: var(--wp--preset--gradient--midnight) !important;
      }
      .has-small-font-size {
        font-size: var(--wp--preset--font-size--small) !important;
      }
      .has-medium-font-size {
        font-size: var(--wp--preset--font-size--medium) !important;
      }
      .has-large-font-size {
        font-size: var(--wp--preset--font-size--large) !important;
      }
      .has-x-large-font-size {
        font-size: var(--wp--preset--font-size--x-large) !important;
      }
      .wp-block-navigation a:where(:not(.wp-element-button)) {
        color: inherit;
      }
      :where(.wp-block-post-template.is-layout-flex) {
        gap: 1.25em;
      }
      :where(.wp-block-post-template.is-layout-grid) {
        gap: 1.25em;
      }
      :where(.wp-block-columns.is-layout-flex) {
        gap: 2em;
      }
      :where(.wp-block-columns.is-layout-grid) {
        gap: 2em;
      }
      .wp-block-pullquote {
        font-size: 1.5em;
        line-height: 1.6;
      }`}
				</style>
				<link rel="stylesheet" id="fl-builder-layout-895-css" href="/assets/planet/scripts/895-layout.css" media="all" />
				<link rel="stylesheet" id="cookie-law-info-css" href="/assets/planet/scripts/cookie-law-info-public.css" media="all" />
				<link rel="stylesheet" id="cookie-law-info-gdpr-css" href="/assets/planet/scripts/cookie-law-info-gdpr.css" media="all" />
				<link rel="stylesheet" id="geotarget-css" href="/assets/planet/scripts/geotarget-public.css" media="all" />
				<link rel="stylesheet" id="SFSImainCss-css" href="/assets/planet/scripts/sfsi-style.css" media="all" />
				<link rel="stylesheet" id="font-awesome-5-css" href="/assets/planet/scripts/all.min.css" media="all" />
				<link rel="stylesheet" id="ultimate-icons-css" href="/assets/planet/scripts/icons-style.css" media="all" />
				<link rel="stylesheet" href="/assets/planet/scripts/6fe8345303f2267cb27e5ce40aeb5b31-layout-bundle.css" media="all" />
				<link rel="stylesheet" id="tablepress-default-css" href="/assets/planet/scripts/default.css" media="all" />
				<link rel="stylesheet" id="jquery-magnificpopup-css" href="/assets/planet/scripts/jquery.magnificpopup.min.css" media="all" />
				{/* <link
      rel="stylesheet"
      id="bootstrap-css"
      href="/assets/planet/scripts/bootstrap.min.css"
      media="all"
    /> */}
				{/* <link
      rel="stylesheet"
      id="fl-automator-skin-css"
      href="/assets/planet/scripts/skin-660ae3670997b.css"
      media="all"
    /> */}
				<link rel="stylesheet" id="fl-child-theme-css" href="/assets/planet/scripts/style.css" media="all" />
				<link rel="stylesheet" id="pp-animate-css" href="/assets/planet/scripts/animate.min.css" media="all" />
				<script src="/assets/planet/scripts/jquery.min.js" nonce=""></script>
				<script src="/assets/planet/scripts/jquery-migrate-3.4.1.js"></script>
				<script id="cookie-law-info-js-extra">
					{` var Cli_Data = {
        nn_cookie_ids: [
          "_ga_*",
          "_ga",
          "CookieLawInfoConsent",
          "cookielawinfo-checkbox-necessary",
          "cookielawinfo-checkbox-functional",
          "cookielawinfo-checkbox-performance",
          "cookielawinfo-checkbox-analytics",
          "cookielawinfo-checkbox-advertisement",
          "cookielawinfo-checkbox-others",
        ],
        cookielist: [],
        non_necessary_cookies: {
          "performance-analytics": ["_ga_*", "_ga"],
          "strictly-necessary": ["CookieLawInfoConsent"],
        },
        ccpaEnabled: "",
        ccpaRegionBased: "",
        ccpaBarEnabled: "",
        strictlyEnabled: ["necessary", "obligatoire"],
        ccpaType: "gdpr",
        js_blocking: "",
        custom_integration: "",
        triggerDomRefresh: "",
        secure_cookies: "",
      };
      var cli_cookiebar_settings = {
        animate_speed_hide: "500",
        animate_speed_show: "500",
        background: "#FFF",
        border: "#b1a6a6c2",
        border_on: "",
        button_1_button_colour: "#00a894",
        button_1_button_hover: "#008676",
        button_1_link_colour: "#fff",
        button_1_as_button: "1",
        button_1_new_win: "",
        button_2_button_colour: "#333",
        button_2_button_hover: "#292929",
        button_2_link_colour: "#444",
        button_2_as_button: "",
        button_2_hidebar: "",
        button_3_button_colour: "#000",
        button_3_button_hover: "#000000",
        button_3_link_colour: "#fff",
        button_3_as_button: "1",
        button_3_new_win: "",
        button_4_button_colour: "#000",
        button_4_button_hover: "#000000",
        button_4_link_colour: "#fff",
        button_4_as_button: "1",
        button_7_button_colour: "#61a229",
        button_7_button_hover: "#4e8221",
        button_7_link_colour: "#fff",
        button_7_as_button: "1",
        button_7_new_win: "",
        font_family: "inherit",
        header_fix: "",
        notify_animate_hide: "1",
        notify_animate_show: "",
        notify_div_id: "#cookie-law-info-bar",
        notify_position_horizontal: "right",
        notify_position_vertical: "bottom",
        scroll_close: "",
        scroll_close_reload: "",
        accept_close_reload: "",
        reject_close_reload: "",
        showagain_tab: "",
        showagain_background: "#fff",
        showagain_border: "#000",
        showagain_div_id: "#cookie-law-info-again",
        showagain_x_position: "100px",
        text: "#000",
        show_once_yn: "",
        show_once: "10000",
        logging_on: "",
        as_popup: "",
        popup_overlay: "1",
        bar_heading_text: "",
        cookie_bar_as: "banner",
        popup_showagain_position: "bottom-right",
        widget_position: "left",
      };`}
				</script>
				<script src="/assets/planet/scripts/cookie-law-info-public.js" id="cookie-law-info-js"></script>
				<script>
					{` var bb_powerpack = {
        search_term: "",
        version: "2.36.4",
        getAjaxUrl: function () {
          return atob(
            "aHR0cHM6Ly93d3cucGxhbmV0LWhlYWx0aGNhcmUuY29tL3dwLWFkbWluL2FkbWluLWFqYXgucGhw"
          );
        },
        callback: function () {},
      };`}
				</script>
				<meta
					name="follow.it-verification-code-czZjQnVUNm9ZVTRzRXdpMGp2cjFienhIdFhOWnVCaEFUeHFLYlFTR3NBckNPUk5GTy9XdDhydW9HSDNWMk1waFhDVEluQ0FybElxZEprYUhESnJQSjVwMk1HY3Y3Wm9oc01mcjJUL3ZEVWhieXBORzJrR1Axa1BQb254bEQzZWN8QmFDUFhXZEpkd25DWXI5OVdNckQ5ZkVZbExCSGNBYk1iT3hQejZEd1lndz0="
					content="sYh5ShePlUq2LdKjWZTa"
				/>
				<style>
					{`    .wpt-clearfix::after {
        display: block;
        clear: both;
        content: "";
      }
      .wpt-testimonial-thumb {
        display: block;
        max-width: 100%;
        height: auto;
        margin: 1em 0;
      }
      .lSAction > a {
        background-image: none !important;
      }
      .hmgfade {
        -webkit-transition: 0.2s opacity ease;
        transition: 0.2s opacity ease;
      }
      .hmgfade-loading {
        opacity: 0;
      }
      .hmgfade-complete {
        opacity: 1;
      } `}
				</style>
				<style id="wp-custom-css">
					{`    .sfsiplus_footerLnk {
        display: none;
      } `}
				</style>
				<script id="fl-theme-custom-js">
					{`     jQuery(document).ready(function () {
        jQuery(".uabb-hamburger-menu-top").attr("height", "5");
        jQuery(".uabb-hamburger-menu-middle").attr("height", "5");
        jQuery(".uabb-hamburger-menu-bottom").attr("height", "5");
      }); `}
				</script>

				<script>
					{`  (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", "GTM-WFKB2RLK");
      `}
				</script>
			</Helmet>

			<footer
				className="fl-builder-content fl-builder-content-25 fl-builder-global-templates-locked"
				data-post-id="25"
				data-type="footer"
				itemscope="itemscope"
				itemtype="http://schema.org/WPFooter"
			>
				<div className="fl-row fl-row-full-width fl-row-bg-color fl-node-5c51010753857 fl-row-default-height fl-row-align-center" data-node="5c51010753857">
					<div className="fl-row-content-wrap">
						<div className="uabb-row-separator uabb-top-row-separator"></div>
						<div className="fl-row-content fl-row-fixed-width fl-node-content" style={{ position: 'relative' }}>
							<div className="fl-col-group fl-node-5c51010753896 fl-col-group-custom-width" data-node="5c51010753896">
								<div className="fl-col fl-node-5c9e556b48c75 fl-col-small fl-visible-desktop fl-visible-large" data-node="5c9e556b48c75">
									<div className="fl-col-content fl-node-content">
										<div className="fl-module fl-module-heading fl-node-5cbf803574047" data-node="5cbf803574047">
											<div className="fl-module-content fl-node-content">
												<h4 className="fl-heading">
													<span className="fl-heading-text">About Us</span>
												</h4>
											</div>
										</div>
										<div className="fl-module fl-module-uabb-advanced-menu fl-node-5cbf803e3afa5" data-node="5cbf803e3afa5">
											<div className="fl-module-content fl-node-content">
												<div className="uabb-creative-menu uabb-creative-menu-accordion-collapse uabb-menu-default">
													<div className="uabb-clear"></div>
													<ul className="menu uabb-creative-menu-vertical uabb-toggle-none">
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/about-us/index">
																<span className="menu-item-text">Our Story</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/about-us/leadership">
																<span className="menu-item-text">Leadership</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/about-us/locations">
																<span className="menu-item-text">Locations</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/about-us/diversity-equity-and-inclusion">
																<span className="menu-item-text">Diversity, Equity, and Inclusion</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/about-us/work-for-us">
																<span className="menu-item-text">Careers At Planet</span>
															</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="fl-col fl-node-5c9e556b48c75 fl-col-small fl-visible-desktop fl-visible-large" data-node="5c9e556b48c75">
									<div className="fl-col-content fl-node-content">
										<div className="fl-module fl-module-heading fl-node-5cbf803574047" data-node="5cbf803574047">
											<div className="fl-module-content fl-node-content">
												<h4 className="fl-heading">
													<span className="fl-heading-text">Client Hub</span>
												</h4>
											</div>
										</div>
										<div className="fl-module fl-module-uabb-advanced-menu fl-node-5cbf803e3afa5" data-node="5cbf803e3afa5">
											<div className="fl-module-content fl-node-content">
												<div className="uabb-creative-menu uabb-creative-menu-accordion-collapse uabb-menu-default">
													<div className="uabb-clear"></div>
													<ul className="menu uabb-creative-menu-vertical uabb-toggle-none">
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/clients/index">
																<span className="menu-item-text">Client Overview</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/clients/why-planet-healthcare">
																<span className="menu-item-text">Why Planet Healthcare</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/clients/solutions">
																<span className="menu-item-text">Solutions</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/clients/practice-areas">
																<span className="menu-item-text">Practice Areas</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/clients/custom-emr-solutions">
																<span className="menu-item-text">Custom EMR Solutions</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/clients/case-studies">
																<span className="menu-item-text">Case Studies</span>
															</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="fl-col fl-node-5c9e556b48c75 fl-col-small fl-visible-desktop fl-visible-large" data-node="5c9e556b48c75">
									<div className="fl-col-content fl-node-content">
										<div className="fl-module fl-module-heading fl-node-5cbf803574047" data-node="5cbf803574047">
											<div className="fl-module-content fl-node-content">
												<h4 className="fl-heading">
													<span className="fl-heading-text">Career Experience</span>
												</h4>
											</div>
										</div>
										<div className="fl-module fl-module-uabb-advanced-menu fl-node-5cbf803e3afa5" data-node="5cbf803e3afa5">
											<div className="fl-module-content fl-node-content">
												<div className="uabb-creative-menu uabb-creative-menu-accordion-collapse uabb-menu-default">
													<div className="uabb-clear"></div>
													<ul className="menu uabb-creative-menu-vertical uabb-toggle-none">
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/career-experience/index">
																<span className="menu-item-text">What You Can Expect</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/career-experience/support">
																<span className="menu-item-text">Working With Us</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/career-experience/services">
																<span className="menu-item-text">Services</span>
															</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div
									className="fl-col fl-node-5c51010753913 fl-col-small fl-col-small-custom-width fl-visible-desktop fl-visible-large"
									data-node="5c51010753913"
								>
									<div className="fl-col-content fl-node-content">
										<div className="fl-module fl-module-heading fl-node-5c81ab91a0983" data-node="5c81ab91a0983">
											<div className="fl-module-content fl-node-content">
												<h4 className="fl-heading">
													<span className="fl-heading-text">Job Openings</span>
												</h4>
											</div>
										</div>
										<div className="fl-module fl-module-uabb-advanced-menu fl-node-5c81ab961a7dc" data-node="5c81ab961a7dc">
											<div className="fl-module-content fl-node-content">
												<div className="uabb-creative-menu uabb-creative-menu-accordion-collapse uabb-menu-default">
													<div className="uabb-clear"></div>
													<ul className="menu uabb-creative-menu-vertical uabb-toggle-none">
														<li className="menu-item menu-item-type-custom menu-item-object-custom uabb-creative-menu uabb-cm-style">
															<a href="https://careers.planet-healthcare.com/">
																<span className="menu-item-text">Job Openings</span>
															</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div
									id="social-media"
									className="fl-col fl-node-5c54e8c5cbfed fl-col-small fl-col-small-custom-width fl-visible-desktop fl-visible-large"
									data-node="5c54e8c5cbfed"
								>
									<div className="fl-col-content fl-node-content">
										<div className="fl-module fl-module-heading fl-node-5c54e8c5cc318" data-node="5c54e8c5cc318">
											<div className="fl-module-content fl-node-content">
												<h4 className="fl-heading">
													<span className="fl-heading-text">Resources</span>
												</h4>
											</div>
										</div>
										<div className="fl-module fl-module-uabb-advanced-menu fl-node-5c54e8c5cc353" data-node="5c54e8c5cc353">
											<div className="fl-module-content fl-node-content">
												<div className="uabb-creative-menu uabb-creative-menu-accordion-collapse uabb-menu-default">
													<div className="uabb-clear"></div>
													<ul className="menu uabb-creative-menu-vertical uabb-toggle-none">
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/blog">
																<span className="menu-item-text">Blog</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/contact-us">
																<span className="menu-item-text">Contact Us</span>
															</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="fl-col fl-node-5ca182df6acb1 fl-col-small fl-visible-desktop fl-visible-large" data-node="5ca182df6acb1">
									<div className="fl-col-content fl-node-content">
										<div className="fl-module fl-module-photo fl-node-5db7379d86d30" data-node="5db7379d86d30">
											<div className="fl-module-content fl-node-content">
												<div className="fl-photo fl-photo-align-center" itemscope="" itemtype="https://schema.org/ImageObject">
													<div className="fl-photo-content fl-photo-img-png">
														<img
															loading="lazy"
															decoding="async"
															className="fl-photo-img wp-image-47826 size-full"
															src="/assets/planet/scripts/joint-comission-vector-1.png"
															alt="Joint commission National Quality Approval Signature graphic"
															itemprop="image"
															height="300"
															width="300"
															title="joint-comission-vector"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div
								className="fl-col-group fl-node-5cbf7ff15b1fe fl-col-group-equal-height fl-col-group-align-top fl-col-group-custom-width"
								data-node="5cbf7ff15b1fe"
							>
								<div
									className="fl-col fl-node-5cbf7ff15b55f fl-col-small fl-col-small-custom-width fl-visible-medium fl-visible-mobile"
									data-node="5cbf7ff15b55f"
								>
									<div className="fl-col-content fl-node-content">
										<div className="fl-module fl-module-heading fl-node-5c54e7f8e308a" data-node="5c54e7f8e308a">
											<div className="fl-module-content fl-node-content">
												<h4 className="fl-heading">
													<span className="fl-heading-text">About Us</span>
												</h4>
											</div>
										</div>
										<div className="fl-module fl-module-uabb-advanced-menu fl-node-5c54e7f8e30c6" data-node="5c54e7f8e30c6">
											<div className="fl-module-content fl-node-content">
												<div className="uabb-creative-menu uabb-creative-menu-accordion-collapse uabb-menu-default">
													<div className="uabb-clear"></div>
													<ul className="menu uabb-creative-menu-vertical uabb-toggle-none">
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/about-us/index">
																<span className="menu-item-text">Our Story</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/about-us/leadership">
																<span className="menu-item-text">Leadership</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/about-us/locations">
																<span className="menu-item-text">Locations</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/about-us/diversity-equity-and-inclusion">
																<span className="menu-item-text">Diversity, Equity, and Inclusion</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/about-us/work-for-us">
																<span className="menu-item-text">Careers At Planet</span>
															</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div
									className="fl-col fl-node-5cbf7ff15b55f fl-col-small fl-col-small-custom-width fl-visible-medium fl-visible-mobile"
									data-node="5cbf7ff15b55f"
								>
									<div className="fl-col-content fl-node-content">
										<div className="fl-module fl-module-heading fl-node-5c54e7f8e308a" data-node="5c54e7f8e308a">
											<div className="fl-module-content fl-node-content">
												<h4 className="fl-heading">
													<span className="fl-heading-text">Client Hub</span>
												</h4>
											</div>
										</div>
										<div className="fl-module fl-module-uabb-advanced-menu fl-node-5c54e7f8e30c6" data-node="5c54e7f8e30c6">
											<div className="fl-module-content fl-node-content">
												<div className="uabb-creative-menu uabb-creative-menu-accordion-collapse uabb-menu-default">
													<div className="uabb-clear"></div>
													<ul className="menu uabb-creative-menu-vertical uabb-toggle-none">
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/clients/index">
																<span className="menu-item-text">Client Overview</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/clients/why-planet-healthcare">
																<span className="menu-item-text">Why Planet Healthcare</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/clients/solutions">
																<span className="menu-item-text">Solutions</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/clients/practice-areas">
																<span className="menu-item-text">Practice Areas</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/clients/custom-emr-solutions">
																<span className="menu-item-text">Custom EMR Solutions</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/clients/case-studies">
																<span className="menu-item-text">Case Studies</span>
															</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div
									className="fl-col fl-node-5cbf7ff15b55f fl-col-small fl-col-small-custom-width fl-visible-medium fl-visible-mobile"
									data-node="5cbf7ff15b55f"
								>
									<div className="fl-col-content fl-node-content">
										<div className="fl-module fl-module-heading fl-node-5c54e7f8e308a" data-node="5c54e7f8e308a">
											<div className="fl-module-content fl-node-content">
												<h4 className="fl-heading">
													<span className="fl-heading-text">Career Experience</span>
												</h4>
											</div>
										</div>
										<div className="fl-module fl-module-uabb-advanced-menu fl-node-5c54e7f8e30c6" data-node="5c54e7f8e30c6">
											<div className="fl-module-content fl-node-content">
												<div className="uabb-creative-menu uabb-creative-menu-accordion-collapse uabb-menu-default">
													<div className="uabb-clear"></div>
													<ul className="menu uabb-creative-menu-vertical uabb-toggle-none">
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/career-experience/index">
																<span className="menu-item-text">What You Can Expect</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/career-experience/support">
																<span className="menu-item-text">Working With Us</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/career-experience/services">
																<span className="menu-item-text">Services</span>
															</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="fl-col-group fl-node-5cbf807066162 fl-col-group-custom-width" data-node="5cbf807066162">
								<div
									className="fl-col fl-node-5cbf807066d32 fl-col-small fl-col-small-custom-width fl-visible-medium fl-visible-mobile"
									data-node="5cbf807066d32"
								>
									<div className="fl-col-content fl-node-content">
										<div className="fl-module fl-module-heading fl-node-5cbf8089dc887" data-node="5cbf8089dc887">
											<div className="fl-module-content fl-node-content">
												<h4 className="fl-heading">
													<span className="fl-heading-text">Job Openings</span>
												</h4>
											</div>
										</div>
										<div className="fl-module fl-module-uabb-advanced-menu fl-node-5cbf80914ff19" data-node="5cbf80914ff19">
											<div className="fl-module-content fl-node-content">
												<div className="uabb-creative-menu uabb-creative-menu-accordion-collapse uabb-menu-default">
													<div className="uabb-clear"></div>
													<ul className="menu uabb-creative-menu-vertical uabb-toggle-none">
														<li className="menu-item menu-item-type-custom menu-item-object-custom uabb-creative-menu uabb-cm-style">
															<a href="https://careers.planet-healthcare.com/">
																<span className="menu-item-text">Job Openings</span>
															</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div
									className="fl-col fl-node-5cbf807066d83 fl-col-small fl-col-small-custom-width fl-visible-medium fl-visible-mobile"
									data-node="5cbf807066d83"
								>
									<div className="fl-col-content fl-node-content">
										<div className="fl-module fl-module-heading fl-node-5cbf808c47f72" data-node="5cbf808c47f72">
											<div className="fl-module-content fl-node-content">
												<h4 className="fl-heading">
													<span className="fl-heading-text">Resources</span>
												</h4>
											</div>
										</div>
										<div className="fl-module fl-module-uabb-advanced-menu fl-node-5cbf809433ef6" data-node="5cbf809433ef6">
											<div className="fl-module-content fl-node-content">
												<div className="uabb-creative-menu uabb-creative-menu-accordion-collapse uabb-menu-default">
													<div className="uabb-clear"></div>
													<ul className="menu uabb-creative-menu-vertical uabb-toggle-none">
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/blog">
																<span className="menu-item-text">Blog</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/contact-us">
																<span className="menu-item-text">Contact Us</span>
															</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div
									className="fl-col fl-node-5cbf807066dc8 fl-col-small fl-col-small-custom-width fl-visible-medium fl-visible-mobile"
									data-node="5cbf807066dc8"
								>
									<div className="fl-col-content fl-node-content">
										<div className="fl-module fl-module-heading fl-node-5cbf808f2000c" data-node="5cbf808f2000c">
											<div className="fl-module-content fl-node-content">
												<h4 className="fl-heading">
													<span className="fl-heading-text">PlanetOne</span>
												</h4>
											</div>
										</div>
										<div className="fl-module fl-module-uabb-advanced-menu fl-node-5cbf80968fe10" data-node="5cbf80968fe10">
											<div className="fl-module-content fl-node-content">
												<div className="uabb-creative-menu uabb-creative-menu-accordion-collapse uabb-menu-default">
													<div className="uabb-clear"></div>
													<ul id="menu-footer-menu-12" className="menu uabb-creative-menu-vertical uabb-toggle-none">
														<li id="menu-item-983" className="menu-item menu-item-type-custom menu-item-object-custom uabb-creative-menu uabb-cm-style">
															<a target="_blank" rel="noopener" href="https://theplanetone.com/">
																<span className="menu-item-text">Login to PlanetOne</span>
															</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="fl-col-group fl-node-5c81ac2429a03" data-node="5c81ac2429a03">
								<div className="fl-col fl-node-5c81ac2429d58" data-node="5c81ac2429d58">
									<div className="fl-col-content fl-node-content">
										<div className="fl-module fl-module-separator fl-node-5c81ac2429674" data-node="5c81ac2429674">
											<div className="fl-module-content fl-node-content">
												<div className="fl-separator"></div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="fl-col-group fl-node-5c81ab8dad7c9 fl-col-group-custom-width" data-node="5c81ab8dad7c9">
								<div className="fl-col fl-node-5c81ab8dadaf0 fl-col-small-custom-width" data-node="5c81ab8dadaf0">
									<div className="fl-col-content fl-node-content"></div>
								</div>
								<div className="fl-col fl-node-5c81abf0df31c fl-col-small fl-col-small-custom-width" data-node="5c81abf0df31c">
									<div className="fl-col-content fl-node-content">
										<div
											className="fl-module fl-module-heading fl-node-5c51010753b0e fl-visible-desktop fl-visible-large fl-visible-medium"
											data-node="5c51010753b0e"
										>
											<div className="fl-module-content fl-node-content">
												<h4 className="fl-heading">
													<span className="fl-heading-text">Social</span>
												</h4>
											</div>
										</div>
										<div className="fl-module fl-module-advanced-icon fl-node-5c803d0b7dc4b" data-node="5c803d0b7dc4b">
											<div className="fl-module-content fl-node-content">
												<div className="uabb-module-content adv-icon-wrap adv-icon-horizontal adv-icon-left">
													<a
														className="adv-icon-link adv-icon-1"
														href="https://www.facebook.com/PlanetHealthcare"
														target="_blank"
														rel="noopener"
														aria-label="Go to https://www.facebook.com/PlanetHealthcare"
													>
														<div className="uabb-module-content uabb-imgicon-wrap">
															<span className="uabb-icon-wrap">
																<span className="uabb-icon">
																	<i className="ua-icon ua-icon-facebook-with-circle"></i>
																</span>
															</span>
														</div>
													</a>
													<a
														className="adv-icon-link adv-icon-2"
														href="https://www.linkedin.com/company/9223341?trk=vsrp_companies_res_name&amp;trkInfo=VSRPsearchId%3A3848952581427974992406%2CVSRPtargetId%3A9223341%2CVSRPcmpt%3Aprimary"
														target="_blank"
														rel="noopener"
														aria-label="Go to https://www.linkedin.com/company/9223341?trk=vsrp_companies_res_name&amp;trkInfo=VSRPsearchId%3A3848952581427974992406%2CVSRPtargetId%3A9223341%2CVSRPcmpt%3Aprimary"
													>
														<div className="uabb-module-content uabb-imgicon-wrap">
															<span className="uabb-icon-wrap">
																<span className="uabb-icon">
																	<i className="ua-icon ua-icon-linkedin-with-circle"></i>
																</span>
															</span>
														</div>
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="fl-row fl-row-full-width fl-row-bg-color fl-node-5c510107523fd fl-row-default-height fl-row-align-center" data-node="5c510107523fd">
					<div className="fl-row-content-wrap">
						<div className="uabb-row-separator uabb-top-row-separator"></div>
						<div className="fl-row-content fl-row-fixed-width fl-node-content" style={{ position: 'relative' }}>
							<div className="fl-col-group fl-node-5c5101075378c fl-col-group-custom-width" data-node="5c5101075378c">
								<div className="fl-col fl-node-5c510107537d7 fl-col-small-custom-width" data-node="5c510107537d7">
									<div className="fl-col-content fl-node-content">
										<div className="fl-module fl-module-uabb-advanced-menu fl-node-5c54e9caa2759 sub-footer-menu" data-node="5c54e9caa2759">
											<div className="fl-module-content fl-node-content">
												<div className="uabb-creative-menu uabb-creative-menu-accordion-collapse uabb-menu-default">
													<div className="uabb-clear"></div>
													<ul id="menu-footer-menu-13" className="menu uabb-creative-menu-horizontal uabb-toggle-none">
														<li className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-907 current_page_item uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/privacy-documents/web-privacy-notice">
																<span className="menu-item-text">Privacy Policy - Website</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-907 current_page_item uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/privacy-documents/cookie-policy">
																<span className="menu-item-text">Cookie Policy</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-907 current_page_item uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/privacy-documents/anti-slavery-policy">
																<span className="menu-item-text">Anti-Slavery Policy</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-907 current_page_item uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/privacy-documents/accessibility-statement">
																<span className="menu-item-text">Accessibility Statement</span>
															</a>
														</li>
														<li className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-907 current_page_item uabb-creative-menu uabb-cm-style">
															<a href="https://www.planet-healthcare.com/privacy-documents/fraud-alert">
																<span className="menu-item-text">Fraud Alert</span>
															</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="fl-col fl-node-5c54e9c14351d fl-col-small fl-col-small-custom-width" data-node="5c54e9c14351d">
									<div className="fl-col-content fl-node-content">
										<div className="fl-module fl-module-rich-text fl-node-5c54e9c1437ab" data-node="5c54e9c1437ab">
											<div className="fl-module-content fl-node-content">
												<div className="fl-rich-text">
													<p className="sub-footer">© 2025 Planet Healthcare</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</footer>
		</>
	)
}
